import axios from "axios";
import { useEffect, useState } from "react";
import Sidenav from "./SIdeNav";
import BackToAdmin from "./BackToAdmin";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InfringementReportPDF from "./InfringementReportPDF";
import SampleReport from "../../../../assets/infringements/Company_Data.xlsx";

// import { PatentContext } from "../context/PatentContextProvider";
export default function RequestedInfringement() {
  const [infringementDetails, setInfringementDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isSidenavOpen, setIsSidenavOpen] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");

  const getViolationAnalysis = async () => {
    try {
      const response = await axios(
        `${process.env.REACT_APP_API_PATH}/getViolationAnalysis`
      );
      if (response.status === 200) {
        setInfringementDetails(
          response.data.filter((item) => {
            return item.isRequested === true;
          })
        );
        setFileName("No file chosen");
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err.message, "Err");
    } finally {
      setLoading(false);
    }
  };

  // const splitTextIntoRows = (text, wordsPerRow) => {
  //   const words = text.split(" ");
  //   const chunks = [];

  //   for (let i = 0; i < words.length; i += wordsPerRow) {
  //     chunks.push(words.slice(i, i + wordsPerRow).join(" "));
  //   }

  //   return chunks;
  // };

  // const generateFullReport = (results) => {
  //   const wordsPerRow = 12;
  //   if (!results || results.length === 0) {
  //     return;
  //   }

  //   const wb = XLSX.utils.book_new(); // Create a new workbook
  //   const sheetNames = [];

  //   // Generate individual sheets for each record
  //   results.forEach((item, index) => {
  //     const {
  //       violationResult,
  //       companyName,
  //       companyEmail,
  //       companyContactNumber,
  //     } = item;
  //     const chunks = splitTextIntoRows(violationResult, wordsPerRow);
  //     const formattedData = [];

  //     // Add record details
  //     chunks.forEach((chunk, rowIndex) => {
  //       formattedData.push({
  //         Company: rowIndex === 0 ? companyName : "",
  //         Contact: rowIndex === 0 ? `'${companyContactNumber}` : "",
  //         Email: rowIndex === 0 ? companyEmail : "",
  //         Findings: chunk,
  //       });
  //     });

  //     // Add a row to go back to index sheet
  //     formattedData.push({ Company: "", Contact: "", Email: "", Findings: `` });

  //     // Convert data to sheet
  //     const ws = XLSX.utils.json_to_sheet(formattedData);

  //     // Set column width for better readability
  //     ws["!cols"] = [
  //       { wch: 20 }, // Company
  //       { wch: 15 }, // Contact
  //       { wch: 25 }, // Email
  //       { wch: 200 }, // Findings
  //     ];

  //     // Store the sheet name
  //     const sheetName = `Record ${index + 1}`;
  //     sheetNames.push({ name: sheetName, link: `#'${sheetName}'!A1` });
  //     XLSX.utils.book_append_sheet(wb, ws, sheetName);
  //   });

  //   // Create an "Index" sheet with links to all records
  //   const indexData = sheetNames.map((item, idx) => ({
  //     Record: `Go to ${item.name}`,
  //   }));

  //   const wsIndex = XLSX.utils.json_to_sheet(indexData);
  //   XLSX.utils.book_append_sheet(wb, wsIndex, "Index");

  //   // Save the workbook
  //   XLSX.writeFile(wb, "Violation_Report.xlsx");
  // };

  // const exportToExcel = (item, fileName) => {
  //     const wordsPerRow = 15;
  //     const splitConclusion = splitTextIntoRows(
  //       item.violationResult,
  //       wordsPerRow
  //     );

  //     const formattedData = splitConclusion.map((chunk, index) => ({
  //       Company: index === 0 ? item.companyName : "",
  //       Contact: index === 0 ? `'${item.companyContactNumber}` : "",
  //       Email: index === 0 ? item.companyEmail : "",
  //       Findings: chunk,
  //     }));

  //     // Create a worksheet from the formatted data
  //     const ws = XLSX.utils.json_to_sheet(formattedData);
  //     ws["!cols"] = [{ wch: 20 }, { wch: 15 }, { wch: 25 }, { wch: 200 }];

  //     // Create a new workbook and append the worksheet
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Data Report");

  //     // Convert workbook to a binary Excel file
  //     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  //     // Convert to Blob and trigger download
  //     const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  //     saveAs(file, `${fileName}.xlsx`);

  // };

  useEffect(() => {
    getViolationAnalysis();
  }, []);

  return (
    <div className="flex flex-col lg:flex-row bg-white min-h-screen w-full flex-nowrap">
      <div className="lg:hidden bg-gray-800 text-white p-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Requested Violations</h1>
        <button
          onClick={() => setIsSidenavOpen(!isSidenavOpen)}
          className="text-white p-2 rounded-md bg-gray-700 hover:bg-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      {/* Sidebar */}
      <div
        className={`${
          isSidenavOpen
            ? "fixed inset-0 transform translate-x-0 bg-gray-800"
            : "fixed inset-0 transform -translate-x-full"
        } lg:relative lg:translate-x-0 lg:w-52 text-white p-4 transition-transform z-50`}
      >
        <Sidenav />
        <button
          onClick={() => setIsSidenavOpen(false)}
          className="lg:hidden absolute top-4 right-4 text-gray-300 hover:text-white"
        >
          Close
        </button>
      </div>
      {/* Main Content */}
      <div className="flex-1 overflow-y-auto h-screen">
        <div
          className={`flex items-center justify-center py-10 pb-7 pt-12 transition-opacity duration-300 ${
            isSidenavOpen ? "opacity-50 pointer-events-none" : ""
          }`}
        >
          {isLoading ? (
            <div className="flex items-center justify-center min-h-screen w-full bg-white">
              <div className="w-20 h-20 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
            </div>
          ) : (
            <div className="w-full  ">
              <div className="pt-7 pl-2 w-full">
                <div className="bg-white shadow-lg  shadow-gray-700 rounded-lg p-5 lg:  w-[90%] mx-auto ">
                  <div className="flex justify-center items-center py-2"></div>
                  <div className="hidden lg:flex justify-between items-center bg-gray-800 p-4 -mt-16 rounded-lg">
                    <h2 className=" text-white  font-semibold  ">
                      Requested Violations
                    </h2>
                    <div className="flex justify-center items-center gap-4">
                      <BackToAdmin />
                    </div>
                  </div>
                  {infringementDetails.length === 0 ? (
                    <div>
                      <h2 className="flex justify-center items-center pt-7">
                        No Data Exists
                      </h2>
                    </div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full bg-white border-collapse rounded-lg shadow-lg">
                        <thead>
                          <tr className="text-gray-800 text-left bg-gray-100">
                            <th className="px-6 py-4 font-semibold w-1/3">
                              {" "}
                              COMPANY NAME
                            </th>
                            <th className="px-6 py-4 font-semibold w-1/3">
                              COMPANY EMAIL
                            </th>
                            <th className="px-4 py-4 font-semibold w-1/6 text-center">
                              CONTACT NUMBER
                            </th>
                            <th className="px-4 py-4 font-semibold w-1/6 text-center">
                              REPORT
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-300">
                          {infringementDetails?.map((val, index) => (
                            <tr
                              key={index}
                              className="hover:bg-gray-50 transition duration-300"
                            >
                              <td className="px-6 py-4 text-gray-800 align-middle">
                                {val.companyName}
                              </td>

                              <td className="px-4 py-4 text-gray-600  align-middle">
                                {val.companyEmail}
                              </td>
                              <td className="px-4 py-4 align-middle">
                                <div className="flex justify-center items-center space-x-3">
                                  {val.companyContactNumber}
                                </div>
                              </td>
                              <td className="px-4 py-4 align-middle">
                                {val.violationResult ? (
                                  <PDFDownloadLink
                                    document={
                                      <InfringementReportPDF data={val} />
                                    }
                                    fileName={`Infringement_Report_${
                                      val.companyName || "Company"
                                    }.pdf`}
                                  >
                                    {({ loading }) =>
                                      loading ? (
                                        <span className="flex justify-center items-center bg-gray-400 px-2 py-2 text-white rounded">
                                          Generating...
                                        </span>
                                      ) : (
                                        <span className="flex justify-center items-center bg-blue-500 hover:bg-blue-600 px-2 py-2 text-white rounded">
                                          View Report
                                        </span>
                                      )
                                    }
                                  </PDFDownloadLink>
                                ) : (
                                  <span className="flex justify-center items-center bg-gray-400 cursor-not-allowed px-2 py-2 text-white rounded">
                                    No Report
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
